import { render, staticRenderFns } from "./ClassSessionEdit.vue?vue&type=template&id=28c40afa"
import script from "../../services/class-session/class-session-edit.js?vue&type=script&lang=js&external"
export * from "../../services/class-session/class-session-edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports